import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=2ce5bcee&scoped=true&"
import script from "./CompanySearch.vue?vue&type=script&lang=js&"
export * from "./CompanySearch.vue?vue&type=script&lang=js&"
import style0 from "./CompanySearch.vue?vue&type=style&index=0&id=2ce5bcee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5bcee",
  null
  
)

export default component.exports